import React, { useState } from "react";
import { Card, CardContent } from "semantic-ui-react";
import MoreInfoModal from "./MoreInfoModal";

const AlternateCard = (props) => {
  const [athleteOpen, setAthleteOpen] = useState(false);
  return (
    <>
      <Card onClick={() => setAthleteOpen(true)}>
        <CardContent>
          <h4>{props.reminder?.title}</h4>
          <p>{props.reminder?.content}</p>
        </CardContent>
      </Card>
      <MoreInfoModal
        reminder={props.reminder}
        open={athleteOpen}
        close={() => setAthleteOpen(false)}
      />
    </>
  );
};

export default AlternateCard;
